<template>
    <div class="amanah">
        <div class="page">
            <div class="subpage">
                <div class="title">PERATURAN TRANSAKSI (TRADING RULES) MULTILATERAL (JFX) PT ABI KOMODITI BERJANGKA</div>
                <div class="content-table">
                    <div style="overflow-x:auto">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Nama Kontrak</th>
                                    <th>Kode Kontrak</th>
                                    <th>Waktu Transaksi</th>
                                    <th>Satuan Kontrak</th>
                                    <th>Mata Uang</th>
                                    <th>Harga Pertik</th>
                                    <th>Jaminan</th>
                                    <th>Jaminan Resiko 70%</th>
                                    <th>Komisi transaksi/sisi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Olein 20 Ton Berjangka</td>
                                    <td>OLE</td>
                                    <td>09.30-17.30 WIB</td>
                                    <td>20.000 Kg</td>
                                    <td>IDR</td>
                                    <td>100.000/lot</td>
                                    <td>16.000.000</td>
                                    <td>11.200.000</td>
                                    <td>150.000</td>
                                </tr>
                                <tr>
                                    <td>Olein 10 Ton Berjangka</td>
                                    <td>OLE</td>
                                    <td>09.30-17.30 WIB</td>
                                    <td>10.000 Kg</td>
                                    <td>IDR</td>
                                    <td>50.000/lot</td>
                                    <td>8.000.000</td>
                                    <td>5.600.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Emas 1 Kg Berjangka</td>
                                    <td>GOL</td>
                                    <td>09.30-17.30 WIB</td>
                                    <td>1.000 gr</td>
                                    <td>IDR</td>
                                    <td>50.000/lot</td>
                                    <td>6.000.000</td>
                                    <td>4.200.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Emas 250 gr Berjangka</td>
                                    <td>GOL250</td>
                                    <td>09.30-17.30 WIB</td>
                                    <td>250 gr</td>
                                    <td>IDR</td>
                                    <td>12.500/lot</td>
                                    <td>5.000.000</td>
                                    <td>3.500.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Emas 100 gr Berjangka</td>
                                    <td>GOL100</td>
                                    <td>09.30-17.30 WIB</td>
                                    <td>100 gr</td>
                                    <td>IDR</td>
                                    <td>5.000/lot</td>
                                    <td>3.000.000</td>
                                    <td>2.100.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Emas Gulir</td>
                                    <td>KGE</td>
                                    <td>08.30-17.30 WIB</td>
                                    <td>1.000 gr</td>
                                    <td>IDR</td>
                                    <td>1.000/lot</td>
                                    <td>6.000.000</td>
                                    <td>4.200.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Indeks Emas</td>
                                    <td>KIE</td>
                                    <td>08.30-17.30 WIB</td>
                                    <td>Rp 10.000/indeks</td>
                                    <td>IDR</td>
                                    <td>10.000/lot</td>
                                    <td>7.000.000</td>
                                    <td>4.900.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Emas 100 oz USD</td>
                                    <td>KEGUSD</td>
                                    <td>Jam Perdagangan Ney York</td>
                                    <td>100 troy ounce</td>
                                    <td>USD</td>
                                    <td>5/lot</td>
                                    <td>2.500</td>
                                    <td>1.750</td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td>Emas 10 oz USD</td>
                                    <td>GUITF</td>
                                    <td>Jam Perdagangan Ney York</td>
                                    <td>10 troy ounce</td>
                                    <td>USD</td>
                                    <td>0.5/lot</td>
                                    <td>1.000</td>
                                    <td>700</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>Emas 100 oz Fixed 10.000</td>
                                    <td>GUI1H10</td>
                                    <td>Jam Perdagangan Ney York</td>
                                    <td>100 troy ounce</td>
                                    <td>USD</td>
                                    <td>5/lot</td>
                                    <td>2.500</td>
                                    <td>1.750</td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td>Kakao Berjangka</td>
                                    <td>CC5</td>
                                    <td>
                                        <div>sesi 1: 08.30-12.30</div>
                                        <div>sesi 2: 16.00-02.00</div>
                                    </td>
                                    <td>5.000 kg</td>
                                    <td>IDR</td>
                                    <td>50.000/lot</td>
                                    <td>6.500.000</td>
                                    <td>4.550.000</td>
                                    <td>50.000</td>
                                </tr>
                                <tr>
                                    <td>Kopi Arabica Berjangka</td>
                                    <td>ACF</td>
                                    <td>
                                        <div>sesi 1: 08.30-12.30</div>
                                        <div>sesi 2: 16.00-02.00</div>
                                    </td>
                                    <td>2.000 kg</td>
                                    <td>IDR</td>
                                    <td>100.000/lot</td>
                                    <td>5.000.000</td>
                                    <td>3.500.000</td>
                                    <td>50.000</td>
                                </tr>
                                <tr>
                                    <td>Kopi Robusta Berjangka</td>
                                    <td>RCF</td>
                                    <td>
                                        <div>sesi 1: 09.30-11.30</div>
                                        <div>sesi 2: 14.00-23.00</div>
                                    </td>
                                    <td>5.000 kg</td>
                                    <td>IDR</td>
                                    <td>50.000/lot</td>
                                    <td>6.000.000</td>
                                    <td>4.200.000</td>
                                    <td>50.000</td>
                                </tr>
                                <tr>
                                    <td>Kontrak Berkala Emas 100 gr</td>
                                    <td>GG100</td>
                                    <td>11.00-15.00 WIB</td>
                                    <td>100 gr</td>
                                    <td>IDR</td>
                                    <td>500/gr</td>
                                    <td>3.000.000</td>
                                    <td>2.100.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Kontrak Berkala Emas 50 gr</td>
                                    <td>GG50</td>
                                    <td>11.00-15.00 WIB</td>
                                    <td>50 gr</td>
                                    <td>IDR</td>
                                    <td>500/gr</td>
                                    <td>2.500.000</td>
                                    <td>1.750.000</td>
                                    <td>100.000</td>
                                </tr>
                                <tr>
                                    <td>Kontrak Berkala Emas 25 gr</td>
                                    <td>GG25</td>
                                    <td>11.00-15.00 WIB</td>
                                    <td>25 gr</td>
                                    <td>IDR</td>
                                    <td>500/gr</td>
                                    <td>1.750.000</td>
                                    <td>1.225.000</td>
                                    <td>80.000</td>
                                </tr>
                                <tr>
                                    <td>Kontrak Berkala Emas 10 gr</td>
                                    <td>GG10</td>
                                    <td>11.00-15.00 WIB</td>
                                    <td>10 gr</td>
                                    <td>IDR</td>
                                    <td>500/gr</td>
                                    <td>1.225.000</td>
                                    <td>875.000</td>
                                    <td>60.000</td>
                                </tr>
                                <tr>
                                    <td>Kontrak Berkala Emas 5 gr</td>
                                    <td>GG5</td>
                                    <td>11.00-15.00 WIB</td>
                                    <td>5 gr</td>
                                    <td>IDR</td>
                                    <td>500/gr</td>
                                    <td>750.000</td>
                                    <td>525.000</td>
                                    <td>40.000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content">
                    <ol>
                        <li class="menu">
                            Order
                            <div class="sub-menu">
                                Untuk transaksi hanya melalui Platform Jaffets Now secara Online , Match Order dan pasang limit harga berdasarkan harga market order
                                / working order. Transaksi <i>hanya dapat dilakukan oleh nasabah sendiri tidak dapat diwakilkan.</i>
                            </div>
                        </li>
                        <li class="menu">
                            Deposit Margin
                            <div class="sub-menu">
                                Nasabah dapat menyetor dana untuk Account nya ke segregated bank account (Rekening Terpisah):
                                <ul style="margin-left: 18px">
                                    <li>
                                        Bank BCA (IDR)
                                        <span>No Rekening</span> <span> : </span> <span>035-319-7956 a/n PT. ABI Komoditi Berjangka</span>
                                    </li>
                                    <li>
                                        Bank CIMB NIAGA (IDR)
                                        <span>No Rekening</span> <span> : </span> <span>86000-8133-700 a/n PT. ABI Komoditi Berjangka</span>
                                    </li>
                                    <li>
                                        Bank CIMB NIAGA (USD)
                                        <span>No Rekening</span> <span> : </span> <span>86000-8134-940 a/n PT. ABI Komoditi Berjangka</span>
                                    </li>
                                </ul>
                                Semua dana transfer harus dilakukan antara Segregated Bank account PT. ABI Komoditi Berjangka dan bank account atas nama Nasabah yang
                                bersangkutan.
                                <br />
                                <i>Catatan : bukti transfer harap di email ke dealing.abicommodity@gmail.com</i>
                            </div>
                        </li>
                        <li class="menu">
                            Penarikan Dana (Withdrawal)
                            <div class="sub-menu">
                                Nasabah yang ingin melakukan penarikan dana diharuskan mengisi formulir penarikan dana yang disediakan oleh PT. ABI Komoditi
                                Berjangka dapat di download pada http://abicommodity.com kemudian di fax ke 021-576-1461 atau email ; dealing.abicommodity@gmail.com
                                <br />
                                Formulir yang diterima PT. ABI Komoditi Berjangka sebelum jam 12.00 wib, proses transfer dana akan dilakukan pada hari yang sama
                                kecuali hari libur Nasional/Perbankan. Sedangkan Formulir yang diterima PT.ABI Komoditi Berjangka setelah jam 12.00 wib, proses
                                transfer dana akan dilakukan pada hari berikutnya (T+1) kecuali hari libur Nasional/Perbankan. <br />
                                Semua dana transfer harus dilakukan antara <b>segregated bank account PT. ABI Komoditi Berjangka</b> dan bank account atas nama
                                Nasabah yang bersangkutan.
                            </div>
                        </li>
                        <li class="menu">
                            Laporan Secara Elektronik
                            <div class="sub-menu">
                                Nasabah tidak akan menerima laporan fisik namun laporan transaksi akan dikirim ke Nasabah sesuai dengan alamat email yang tercantum
                                dalam Formulir Pembukaan Rekening. Agar pengiriman laporan sesuai, Nasabah harus menginformasikan alamat email yang benar atau
                                menginformasikan jika adanya perubahan alamat email ke <b>PT. ABI Komoditi Berjangka</b>.
                            </div>
                        </li>
                        <li class="menu">
                            Auto Pull/Cancel Order
                            <div class="sub-menu">
                                Pada waktu penutupan hari perdagangan setiap hari nya,semua transaksi nasabah atau working order akan cancel secara otomatis oleh
                                system.
                            </div>
                        </li>
                        <li class="menu">
                            Margin Call dan Auto Cut Equity
                            <div class="sub-menu">
                                Nasabah wajib memelihara/memenuhi tingkat Margin yang harus tersedia di rekening sesuai dengan jumlah yang telah ditetapkan baik
                                diminta ataupun tidak oleh perusahaan . Margin Call terjadi apabila Equity ratio Nasabah dibawah 100% dari Margin Requirement atas
                                posisi terbuka. Nasabah diwajibkan menambah sejumlah dana supaya memenuhi Margin yang dibutuhkan. Nasabah dilarang membuka posisi
                                baru sampai kewajiban tersebut terpenuhi, yang mana jika kewajiban tersebut tidak dilaksanakan oleh Nasabah maka perusahaan berhak
                                sepenuhnya untuk me-likuidasi posisi terbuka Nasabah baik sebagian atau seluruhnya tanpa perlu persetujuan dari Nasabah terlebih
                                dahulu. Apabila Equity nasabah turun mencapai atau lebih sedikit dari 30% ( tiga puluh persen) dari Margin Requirement maka PT. ABI
                                Komoditi Berjangka akan melikuidasi seluruh posisi nasabah secara otomatis tanpa perlu persetujuan nasabah.
                            </div>
                        </li>
                        <li class="menu">
                            Over Trading
                            <div class="sub-menu">
                                Sistem akan menolak posisi nasabah apabila Nasabah melakukan transaksi yang melebihi dana atau margin yang ada.
                            </div>
                        </li>
                        <li class="menu">
                            Penyelesaian Fisik
                            <div class="sub-menu">
                                Apabila terjadi penyerahan fisik maka akan diatur sesuai dengan ketentuan bursa BBJ (Bursa Berjangka Jakarta) dan Lembaga Kliring
                                PT.KBI ( Kliring Berjangka Indonesia ), dengan berdasarkan ketentuan-ketentuan yang berlaku pada saat melakukan
                                transaksi/penyelesaian fisik. Semua pihak yang mempunyai posisi terbuka, diwajibkan untuk setiap saat mempersiapkan proses penyerahan
                                atau penerimaan fisik untuk sebagai mana mestinya pihak penjual (SELLER) dan pihak pembeli (BUYER) dapat menyetorkan dana Margin
                                minimum 30% dari nilai kontrak yang besarnya di tentukan oleh LEMBAGA KLIRING KBI.
                            </div>
                        </li>
                    </ol>
                    <div class="text-center">
                        <b>
                            Dengan menandatangani dokumen ini,saya menyatakan bahwa saya telah membaca tentang PERATURAN PERDAGANGAN (TRADING RULES), mengerti dan
                            memahami ketentuan dalam bertransaksi”.
                        </b>
                    </div>
                    <div class="persetujuan">
                        <div class="wrap-signature">
                            <div>{{ dataPrint.tempat_ttd }}, {{ currentDate | formatDateTime }}</div>
                            <div>Nasabah</div>
                            <img :src="dataPrint.tandaTangan" alt="" class="tanda-tangan" />
                            <p style="text-transform: capitalize">{{ dataPrint.fullname }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content text-center">
                    <h5>Brosure Trading Rules Jafets Now</h5>
                    <fieldset class="attachment__content" style="margin:0px;padding:0px; width: 100%;">
                        <iframe :src="imgPreview" frameborder="0" style="height:100vh" height="100vh" width="150%"> </iframe>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from "axios";
export default {
    props: {
        fullName: String,
        dataPrint: Object,
    },
    data() {
        return {
            currentDate: "",
            customer_complaints_settlement: "",
            imgPreview: "",
            // urlPdf: require("../brosure_jfx.pdf"),
        };
    },
    created() {
        if (this.dataPrint.tanggal_diterima) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
        Axios.get("/v2/get/file/assets/pdf/Trading-Rules-Brosur-JFX.pdf", { responseType: "blob" }).then((res) => {
            this.imgPreview = URL.createObjectURL(new Blob([res.data], { type: res.data.type }));
        });
        // console.log(img);
    },
    methods: {
        customerComplaint(e) {
            this.customer_complaints_settlement = e.target.value;
            this.$emit("selectCustomerComplaint", this.customer_complaints_settlement);
            this.$root.$emit("selectCustomerComplaint", this.customer_complaints_settlement);
        },
    },
};
</script>

<style scoped>
.tanda-tangan {
    width: 35%;
}

tr:nth-child(even) {
    background-color: #f2f2f2;
}

.page {
    padding: 20px;
    border-radius: 5px;
    background: white;
    position: relative;
    color: black;
}

.attachment__content {
    padding: 1.5rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.radio {
    margin: 0 60px 0 -10px;
    line-height: 35px;
}

.radio .inner {
    width: 11px;
    height: 11px;
}

.radio .outer {
    width: 15px;
    height: 15px;
}

.label {
    width: 130px;
    margin-right: 15px;
}

.uppercase {
    text-transform: lowercase;
}

.uppercase:first-letter,
.uppercase:first-line {
    text-transform: capitalize;
}

.wrap-document {
    width: 90%;
    margin: auto;
    padding: 30px 50px;
    /* border-style: outset; */
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0px auto 40px;
    font-size: 14px;
    width: 69%;
}

.perjanjian {
    text-align: center;
    border: solid 2px #4a4a4a;
    padding: 10px 30px;
    margin: 0 0 30px;
}

.content {
    font-size: 11.5px;
    text-align: justify;
}

.content-table {
    font-size: 10px;
}

.content-table table td {
    padding: 0.3rem 0.3rem;
    text-align: center;
    vertical-align: middle;
}

.content-table table td:nth-child(1) {
    text-align: left;
}

.menu {
    font-weight: bold;
    margin-bottom: 10px;
}

.sub-menu {
    font-weight: normal;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

ol {
    margin-left: 18px;
}

.penutup {
    /* text-align: center; */
    font-size: 12px;
}

.penutup p {
    margin: 0;
}

.resiko {
    font-weight: 700;
}

.persetujuan {
    font-size: 12px;
    display: flex;
    justify-content: end;
    margin-top: 1rem;
}

.wrap-signature {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    position: absolute;
    width: 90%;
    bottom: 10px;
}

@page {
    size: A4;
    margin: 0;
}

@media print {
    .amanah {
        width: 210mm;
        height: 297mm;
    }
    .wrap-document {
        margin: 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
    }
}

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .title {
        margin: 20px auto !important;
    }

    .page {
        min-height: 440mm;
        padding: 0;
    }
}
</style>
